import { markRaw } from 'vue'
import WidgetEmbedModal from '@/components/modals/widget-embed/WidgetEmbedModal.vue'
import PlaylistEmbedModal from '@/components/modals/widget-embed/PlaylistEmbedModal.vue'
import { ModalType, initAndRevealMainModal } from '@/components/modals/modals-util'
import { IModalProps } from '@/store/custom-modal.module'
import { CustomModalProps } from '@/interfaces'
import i18n from '@/i18n'
import embedIcon from '@/assets/popups/embed.svg'
import EmbedModalFooter from '@/components/modals/widget-embed/EmbedModalFooter.vue'
import VideoEmbedModal from '@/components/modals/widget-embed/VideoEmbedModal.vue'

export interface WidgetEmbedModalProps extends CustomModalProps {
  widgetId: number
  widgetName: string
}

export interface PlaylistEmbedModalProps extends CustomModalProps {
  playlistId: number
  playlistName: string
}

export interface VideoEmbedModalProps extends CustomModalProps {
  videoId: string
  videoName: string
}

export type InitWidgetEmbedModal = (props: WidgetEmbedModalProps) => void
export type InitPlaylistEmbedModal = (props: PlaylistEmbedModalProps) => void
export type InitVideoEmbedModal = (props: VideoEmbedModalProps) => void

export const useWidgetEmbedModal = () => {
  const initWidgetEmbedModal: InitWidgetEmbedModal = (customProps: WidgetEmbedModalProps) => {
    const { widgetId, widgetName } = customProps

    const modalConfig: IModalProps = {
      modalType: ModalType.WIDGET_EMBED_MODAL,
      props: {
        noFooter: true,
        headerProps: {
          text: i18n.global.t('embed-widget'),
          textSecondary: widgetName,
          icon: embedIcon
        },
        extraProps: {
          widgetId,
          widgetName
        }
      },
      componentContent: markRaw(WidgetEmbedModal),
      componentFooter: markRaw(EmbedModalFooter)
    }

    initAndRevealMainModal(modalConfig)
  }

  const initPlaylistEmbedModal: InitPlaylistEmbedModal = (customProps: PlaylistEmbedModalProps) => {
    const { playlistId, playlistName } = customProps
    const modalConfig: IModalProps = {
      modalType: ModalType.PLAYLIST_EMBED_MODAL,
      props: {
        noFooter: true,
        headerProps: {
          text: i18n.global.t('embed-playlist-title'),
          textSecondary: i18n.global.t('embed-playlists-to-widget-secondary'),
          icon: embedIcon
        },
        extraProps: {
          playlistId,
          playlistName
        }
      },
      componentContent: markRaw(PlaylistEmbedModal),
      componentFooter: markRaw(EmbedModalFooter)
    }

    initAndRevealMainModal(modalConfig)
  }

  const initVideoEmbedModal: InitVideoEmbedModal = (customProps: VideoEmbedModalProps) => {
    const { videoId, videoName } = customProps
    const modalConfig: IModalProps = {
      modalType: ModalType.PLAYLIST_EMBED_MODAL,
      props: {
        footerProps: {
          buttonCancel: i18n.global.t('close')
        },
        headerProps: {
          text: i18n.global.t('widget-embed-action') + ' ' + i18n.global.t('video'),
          textSecondary: videoName,
          icon: embedIcon
        },
        extraProps: {
          videoId,
          videoName
        }
      },
      componentContent: markRaw(VideoEmbedModal)
    }

    initAndRevealMainModal(modalConfig)
  }

  return {
    initWidgetEmbedModal,
    initPlaylistEmbedModal,
    initVideoEmbedModal
  }
}
